
class ModalManager {
    constructor() {
        this.modals = new Map();
        this.openModalStack = [];
    }

    register(id, showCallback = null, hideCallback = null, shownCallback = null, hiddenCallback = null, options = {}) {
        if (this.modals.has(id)) {
            console.warn(`Modal with ID ${id} is already registered`);
            return this.modals.get(id);
        }

        const modalElement = document.getElementById(id);
        if (!modalElement) {
            throw new Error(`Modal with ID ${id} not found`);
        }

        const modal = new bootstrap.Modal(modalElement, options);

        // Gestione eventi
        modalElement.addEventListener('show.bs.modal', () => {
            this._handleModalShow(id, modalElement);
            if (showCallback != null) {
                showCallback();
            }
        });

        modalElement.addEventListener('shown.bs.modal', () => {

            this._adjustModalZIndex(id);
            this._focusFirstElement(modalElement);
            const modalFound = this.modals.get(id);
            if (modalFound) {
                modalFound.isShown = true;
                  
            }
            if (shownCallback != null) {
                shownCallback();
            }
 });

        modalElement.addEventListener('hide.bs.modal', () => {
                       
            if (hideCallback != null) {
                hideCallback();
            }
        });
        modalElement.addEventListener('hidden.bs.modal', () => {
            this._handleModalHidden(id);
            if (hiddenCallback != null) {
                hiddenCallback();
            }
        });

        this.modals.set(id, {
            instance: modal,
            element: modalElement,

            closeBooked: false,
            isShown: false,
            openRequests: 0
});

        return modal;
    }

    _handleModalShow(id, modalElement) {
        if (!this.openModalStack.includes(id)) {
            this.openModalStack.push(id);
        }
       
        modalElement.style.display = 'block';
    }

    _adjustModalZIndex(id) {
        const modalData = this.modals.get(id);
        if (!modalData) return;

        const baseZIndex = 1050;
        const index = this.openModalStack.indexOf(id);
        if (index !== -1) {
            modalData.element.style.zIndex = baseZIndex + (index * 10);

            // Aggiorna anche il backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            const currentBackdrop = backdrops[backdrops.length - 1];
            if (currentBackdrop) {
                currentBackdrop.style.zIndex = baseZIndex + (index * 10) - 1;
            }
        }
    }

    _focusFirstElement(modalElement) {
        const focusable = modalElement.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusable) {
            focusable.focus();
        }
    }

    _handleModalHidden(id) {
        const modalFound = this.modals.get(id);
        if (modalFound) {
            modalFound.isShown = false;
        }
        
        // Rimuovi la modal dallo stack
        this.openModalStack = this.openModalStack.filter(modalId => modalId !== id);

        // Riorganizza gli z-index delle modal rimanenti
        this.openModalStack.forEach((modalId, index) => {
            const modalData = this.modals.get(modalId);
            if (modalData) {
                modalData.element.classList.remove('modal-background');
                modalData.element.style.zIndex = 1050 + (index * 10);
            }
        });

        // Gestisci il focus sulla modal superiore se presente
        if (this.openModalStack.length > 0) {
            const topModalId = this.openModalStack[this.openModalStack.length - 1];
            const topModalData = this.modals.get(topModalId);
            if (topModalData) {
                topModalData.element.classList.remove('modal-background');
                this._focusFirstElement(topModalData.element);
                if (topModalData.closeBooked == true) {
                    this.hide(topModalId)
                }               
            }
        }

        // Aggiorna i backdrop
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach((backdrop, index) => {
            backdrop.style.zIndex = 1040 + (index * 10);
        });
    }

    show(id) {
        const modalData = this.modals.get(id);
        if (!modalData) {
            throw new Error(`Modal with ID ${id} not registered`);
        }
        
        // Aggiungi effetto di background alle altre modal
        if (this.openModalStack.length > 0) {
            const currentTopModalId = this.openModalStack[this.openModalStack.length - 1];
            if (currentTopModalId !== id) {
                const currentTopModalData = this.modals.get(currentTopModalId);
                if (currentTopModalData) {
                    currentTopModalData.element.classList.add('modal-background');
                }
            }
        }
        modalData.closeBooked = false;
        modalData.openRequests = modalData.openRequests + 1;  
        console.log('[DEBUG] .show() is called. modalData.openRequests: ', modalData.openRequests)
        modalData.instance.show();
    }

    hide(id) {
        console.log('[DEBUG] .hide() called on ' + id);
        const modalData = this.modals.get(id);
        if (modalData) {
            modalData.closeBooked = true;
            modalData.openRequests = modalData.openRequests <= 0 ? 0 : modalData.openRequests - 1;
            console.log('[DEBUG] .show() is called. modalData.openRequests: ', modalData.openRequests)
            if (modalData.openRequests == 0) {
                if (modalData.isShown == false) {
                    console.log('[DEBUG] .hide() is called but IS NOT shown: base .hide() non verrà eseguita');
                } else {
                    console.log('[DEBUG] .hide() is called and modal IS shown');
                    modalData.instance.hide();

                }
            } else {
                console.log('[DEBUG] .hide() is called but callstack is != 0: ', modalData.openRequests );
            }
             //if (document.getElementById('LoadingModal') !== null) {
              //    $('#' + id).modal('hide');
              //    $('#' + id).removeClass('show');
              //    document.getElementById('LoadingModal').style.display = "none";
              //}}
            
        } else {
            console.log('[DEBUG] .hide(): "LoadingModal" not exists', modalData)
        }
    }

    closeAll() {
        [...this.openModalStack].forEach(id => {
            const modalData = this.modals.get(id);
            if (modalData) {
                modalData.instance.hide();
            }
        });
        this.openModalStack = [];
    }

    // Metodo per ottenere l'attuale stack delle modal
    getOpenModals() {
        return [...this.openModalStack];
    }
}

// CSS necessario
//const style = document.createElement('style');
//style.textContent = `
//.modal-background {
//    opacity: 0.5 !important;
//    pointer-events: none !important;
//}
//.modal {
//    transition: opacity 0.15s linear;
//}
//`;
//document.head.appendChild(style);

class app {

    LoadingModalIstance = null;
    SystemGenericModalIstance = null;
    ModalManagerIstance = null;

    constructor() {
        this.ModalManagerIstance = new ModalManager();
        this.LoadingModalIstance = new LoadingModal('LoadingModal');
        this.SystemGenericModalIstance = new SystemGenericModal('SystemMessageModal');

        this.ModalManagerIstance.register('LoadingModal', null, null);
        this.ModalManagerIstance.register('SystemMessageModal', null, null);

        //provvisorio
        //const style = document.createElement('style');
        //style.textContent = `
        //.modal-background {
        //    opacity: 0.5;
        //    pointer-events: none;
        //}
        //`;
        //document.head.appendChild(style);

        var evBuild = new Event('appBuilt');
        setTimeout(function () {
            document.dispatchEvent(evBuild);
        }, 200);
    }

}